import React from 'react'
import emjcof from './emojiconf'
var biliImgEmj = (text, det) =>`<emoji style="vertical-align: middle;"><span class="emotion-inline emotion-item" style="margin-left: 0px;margin-right: 0px;"><img src="${emjcof.bili.host}${text}.png" class="img" style="animation-duration: ${det[0]};animation-timing-function:  ${det[1]};transform: ${det[2]};height:${det[3]}" /></span></emoji>`
var tiebaEmj = (text) =>`<emoji style="vertical-align: middle;"><img src="${emjcof.tieba.host}${text}.gif" alt=":huaji:" class="wp-smiley" style="height: 2rem; max-height: 30px;vertical-align: middle;transform: translateY(-2px);"></emoji>`


var paragraph = (value) => {
    if (typeof (value) == "string") {
        var newValue = value
        var emjdata=emjcof.bili.text
        var imjtieba = emjcof.tieba.text
        var resArr = []
        var hasBiEmj=false
        var hasTeEmj = false
        emjdata.forEach((item,index) => {
            if (newValue.indexOf(':emj-bili-' + item.value + ':') >= 0) {
                hasBiEmj=true
                var exg = "/:emj-bili-" + item.value + ":/g"
                newValue = newValue.replace(eval(exg),  biliImgEmj(item.value, item.det))
            }
                
        })
        

            imjtieba.forEach((item,index) => {

                if (newValue.indexOf(':emj-tieba-' + item + ':') >= 0) {
                    hasTeEmj=true
                    var exg = "/:emj-tieba-" + item + ":/g"
                 newValue = newValue.replace(eval(exg),  tiebaEmj(item))
                }
                // if(index==imjtieba.length-1){
                //     if(hasTeEmj){
                       
                //         var HTML = <boxs dangerouslySetInnerHTML={{ __html: newValue }} />;
                //         resArr.push(HTML)
                //         // str = str.match(/<emoji>(\S*)<\/emoji>/)[1];
                //         // resArr.push(<emoji dangerouslySetInnerHTML={{ __html: str }} />)
                //     }else{
                //         resArr.push(newValue)
                //     }
                  
                    
                //     console.log("newValue",newValue)
                // }
            })

                if(hasBiEmj||hasTeEmj){
                  
                    var HTML = <boxs dangerouslySetInnerHTML={{ __html: newValue }} />;
                    resArr.push(HTML)
                    // str = str.match(/<emoji>(\S*)<\/emoji>/)[1];
                    // resArr.push(<emoji dangerouslySetInnerHTML={{ __html: str }} />)
                }else{
                    resArr.push(newValue)
                }
        

        return resArr;
    }
}

export default paragraph